import { useCallback, useState } from 'react';
import { useSnackbar } from 'notistack';
import { useIntl } from 'react-intl';

import { getResponseMessage } from '../../../../utils/utils';
import { postCompleteBalanceRequest } from '../../../../crud/balanceRequest.crud';
import { IPostCompleteData } from '../../../../interfaces/balanceRequest';

type UseApproveReturn = [
  (paymentId: string, data: IPostCompleteData) => Promise<void>,
  boolean,
  boolean
];

export const useApprove = (): UseApproveReturn => {
  const intl = useIntl();
  const { enqueueSnackbar } = useSnackbar();
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  
  const fetchApprove = useCallback(async (paymentId: string, data: IPostCompleteData) => {
    setLoading(true);
    setSuccess(false);

    try {
      await postCompleteBalanceRequest(paymentId, data);

      enqueueSnackbar('Successfully approveded', {
        variant: 'success',
      });

      setSuccess(true);
    } catch (e) {
      enqueueSnackbar(
        `${intl.formatMessage({ id: 'ERROR' })}: ${getResponseMessage(e)}`,
        { variant: 'error' }
      );
      setSuccess(false);
    } finally {
      setLoading(false);
    }
  }, [enqueueSnackbar, intl]);

  return [fetchApprove, loading, success];
};
